import { faCircleCheck, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import './UniModalLinkNew.scss';
import { ChangeEvent, useEffect, useState } from 'react';
import UniInput from "../UniInput/UniInput";
import UniModal from "../UniModal/UniModal";
import { useTranslation } from 'react-i18next';
import { Country, createLink, getCountries } from '../../services/usefulLinkService';

const UniModalLinkNew = (props: any) => {

    const [showForm, setShowForm] = useState(false);
    const [showError, setShowError] = useState(false);
    const [showModalSuccess, setShowModalSuccess] = useState(false);
    const [showModalError, setShowModalError] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [errorTitle, setErrorTitle] = useState<string>('');
    const [errorDescription, setErrorDescription] = useState<string>('');
    const [errorLink, setErrorLink] = useState<string>('');
    const [errorCountry, setErrorCountry] = useState<string>('');
    const [titleBR, setTitleBR] = useState<string>('');
    const [titleES, setTitleES] = useState<string>('');
    const [titleEN, setTitleEN] = useState<string>('');
    const [descriptionBR, setDescriptionBR] = useState<string>('');
    const [descriptionES, setDescriptionES] = useState<string>('');
    const [descriptionEN, setDescriptionEN] = useState<string>('');
    const [link, setLink] = useState<string>('');
    const [status, setStatus] = useState<string>('');
    const [country, setCountry] = useState<string>('');
    const [loading, setLoading] = useState(false);
    const { i18n, t } = useTranslation();
    const [error, setError] = useState<string>();
    const [countries, setCountries] = useState<Country[] | undefined>();

    const clearFields = () => {
        setTitleBR('');
        setTitleES('');
        setTitleEN('');
        setDescriptionBR('');
        setDescriptionES('');
        setDescriptionEN('');
        setLink('');
    }

    const hide = () => {
        setShowModalSuccess(false);
        setErrorTitle('');
        setErrorDescription('');
        setErrorLink('');
        setErrorCountry('');
        setShowForm(false);
        clearFields();
        props.onHide();
    }

    useEffect(() => {
        if (props.show && !showForm) {
            setShowForm(true);
            getGroupsLink();
        }
    }, [props.show]);

    const createNewLink = async (event:any) => {

        console.log(country)
        event.preventDefault();
        event.stopPropagation();
        var isValid = onValidation();

        if(isValid){
            const response = await createLink(titleBR, titleES, titleEN, descriptionBR, descriptionES, descriptionEN, link, true, country);

            if (response.success) {
                hide();
                getGroupsLink();
                setShowModalSuccess(true);
            }
            else {
                setShowError(true);
                setShowModalError(true);
            }
        }
    }

    const getGroupsLink = () =>{
        setLoading(true);
        getCountries()
        .then(response => {
            if (!response.success) {
                setError(response.error);
            }
            else {
                setCountries(response.countries);
            }
        })
        .catch(e => console.log(e))
        .finally(() => setLoading(false));

    };

    const getCountryDescription = (country : Country) => {
        switch (i18n.language) {
          case 'es':
            return country.descriptionES;
          case 'en':
            return country.descriptionEN;
          default:
            return country.descriptionBR;
        }
      };

    const onValidation = (): Boolean => {
        let isValid = true;
        if (titleBR === '' || titleES === '' || titleEN === '') {
            setErrorTitle(t('link.errorTitle'));
            isValid = false;
        } else {
            setErrorTitle('');
        }
        if (descriptionBR === '' || descriptionES === '' || descriptionEN === '') {
            setErrorDescription(t('link.errorDescription'));
            isValid = false;
        } else {
            setErrorDescription('');
        }

        if (country === '') {
            setErrorCountry(t('link.errorCountry'));
            isValid = false;
        } else {
            setErrorCountry('');
        }

        if (link === '') {
            setErrorLink(t('link.errorLink'));
            isValid = false;
        } else {
            setErrorLink('');
        }

        return isValid;
    }

    const getStatusValue = (e: ChangeEvent<HTMLSelectElement>) => {
        setStatus(e?.target?.value);
    }

    const onChangeCountry = (e: ChangeEvent<HTMLSelectElement>) => {

        setCountry(e?.target?.value);
        console.log(country)
    }

    return (
        <>
            <Modal
                show={props.show}
                onHide={() => hide()}
                className={showForm ? 'modal-link modal-form-link' : 'modal-link'}
                contentClassName={ ''}
            >
                <Modal.Header closeButton>
                    <div className='header-body'>
                        <Modal.Title className='mt-3'>
                            {showForm ? t('link.labelCreateLink') : t('link.labelLinks')}
                        </Modal.Title>
                    </div>
                </Modal.Header>

                <Modal.Body>
                    {
                        <Form onSubmit={createNewLink} className='form-link'>
                            <div className='d-flex flex-column align-items-center justify-content-between form-link-content'>

                     
                                    <div className='profile-inputs'>
                                        <div className='d-flex'>
                                            <label className='label'>{t('link.labelCountry')}</label>
                                        </div>
                                        <div className='d-flex select-countries'>

                                        {
                                             loading ? (<Spinner style={{ color: '#027948', width: 25, height: 25 }} />) : (
                                                <UniInput
                                                id='country'
                                               // label={t('link.labelCountry')}
                                                isSelect
                                                defaultValue={''}
                                                onChange={e => onChangeCountry(e)}
                                            >
                                                <option value={''}>{t('link.labelSelect')}</option>
                                                 {countries?.map(country => (
                                                    <option key={country.id} value={country.id}>
                                                     { getCountryDescription(country)}
                                                    </option>
                                                ))}
                                            </UniInput>
                                             )
                                        }
                                    </div>

                                        {errorCountry && (<p className='p-error'>{errorCountry}</p>)}
                                    </div>

                                {/* </div> */}

                                <div className='profile-inputs'>
                                    <div className='input-group'>
                                        <div className='d-flex flex-column align-items-start'>
                                            <label className='label'>{t('link.labelTitlePT')}</label>

                                            <div style={{margin:'0px 10px 0px 0px'}}>
                                                <UniInput id='titleBR' type='text' value={titleBR} onChangeInput={(e) => setTitleBR(e?.target?.value ?? '')} />
                                            </div>
                                        </div>

                                        <div className='d-flex flex-column align-items-start'>
                                            <label className='label'>{t('link.labelTitleES')}</label>

                                            <div >
                                                <UniInput id='titleES' type='text' value={titleES} onChangeInput={(e) => setTitleES(e?.target?.value ?? '')} />
                                            </div>
                                        </div>

                                        <div className='d-flex flex-column align-items-start'>
                                            <label className='label'>{t('link.labelTitleEN')}</label>

                                            <div >
                                                <UniInput id='titleEN' type='text' value={titleEN} onChangeInput={(e) => setTitleEN(e?.target?.value ?? '')} />
                                            </div>
                                        </div>
                                    </div>
                                    {errorTitle && (<p className='p-error'>{errorTitle}</p>)}
                                    <div className='input-group'>
                                        <div className='d-flex flex-column align-items-start'>
                                            <label className='label'>{t('link.labelDescriptionPT')}</label>

                                            <div style={{margin:'0px 10px 0px 0px'}}>
                                                <UniInput id='descriptionBR' type='text' value={descriptionBR} onChangeInput={(e) => setDescriptionBR(e?.target?.value ?? '')} />
                                            </div>
                                        </div>

                                        <div className='d-flex flex-column align-items-start'>
                                            <label className='label'>{t('link.labelDescriptionES')}</label>

                                            <div >
                                                <UniInput id='descriptionES' type='text' value={descriptionES} onChangeInput={(e) => setDescriptionES(e?.target?.value ?? '')} />
                                            </div>
                                        </div>

                                        <div className='d-flex flex-column align-items-start'>
                                            <label className='label'>{t('link.labelDescriptionEN')}</label>

                                            <div >
                                                <UniInput id='descriptionEN' type='text' value={descriptionEN} onChangeInput={(e) => setDescriptionEN(e?.target?.value ?? '')} />
                                            </div>
                                        </div>
                                    </div>

                                    {errorDescription && (<p className='p-error'>{errorDescription}</p>)}

                                    <div className='d-flex flex-column align-items-start w-100 '>
                                        <label className='label'>{t('link.labelLink')}</label>

                                        <div className="link" style={{width:'650px'}}>
                                            <UniInput id='link' type='text' value={link} onChangeInput={(e) => setLink(e?.target?.value ?? '')} />
                                        </div>
                                    </div>

                                    {errorLink && (<p className='p-error'>{errorLink}</p>)}
                                </div>




                            </div>

                            <div className='buttons-user-form d-flex'>
                                <Button
                                    variant='outline'
                                    disabled={loading}
                                    onClick={() => {
                                        hide();
                                    }
                                    }>
                                    {t('user.labelBack')}
                                </Button>
                                <Button type='submit' disabled={loading}>{loading ? <Spinner style={{ width: 20, height: 20 }} /> : t('user.labelSave')}</Button>
                            </div>
                        </Form>
                    }
                </Modal.Body>
            </Modal>
            <UniModal
                icon={faCircleCheck}
                title={t('link.createdTitle')}
                message={t('link.createdMsg')}
                show={showModalSuccess}
                onHide={() => {
                    setShowModalSuccess(false);
                }}
                isFontAwsome
                iconWidth={100}
                iconHeight={110}
            >
                <div className='modal-body-resume'>
                    <p></p>
                    <Button onClick={() => setShowModalSuccess(false)}>Ok!</Button>
                </div>
            </UniModal>
            <UniModal
                icon={faXmarkCircle}
                title={t('link.createError')}
                message=''
                iconColor='#EA2027'
                show={showModalError}
                onHide={() => {
                    setShowModalError(false);
                }}
                isFontAwsome
                iconWidth={100}
                iconHeight={110}
            >
                <div className='modal-body-resume'>
                    <p>{errorMessage}</p>
                    <Button onClick={() => setShowModalError(false)}>Ok</Button>
                </div>
            </UniModal>
        </>
    );
}

export default UniModalLinkNew;